// import qs from 'qs'
import axios from 'axios'

export const milestoneService = ({
  getMilestoneInformation (token) {
    return axios.get('/api/MilestoneInfo', {headers: {'Authorization': 'Bearer ' + token}})
  },
  addMilestone (token, milestoneObj) {
    return axios.post('/api/Milestone', milestoneObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  getMilestoneList (token, groupId) {
    return axios.get('/api/Milestone?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMilestoneTitleList (token, milestoneInfoId, groupId) {
    return axios.get('/api/Milestone/List?milestoneInfoId=' + milestoneInfoId + '&groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMilestone (token, milestoneObj) {
    return axios.put('/api/Milestone', milestoneObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  deleteMilestone (token, milestoneId) {
    return axios.delete('/api/Milestone?milestoneId=' + milestoneId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMilestoneActionList (token, milestoneId) {
    return axios.get('/api/MilestoneAction?milestoneId=' + milestoneId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  addMilestoneAction (token, milestoneActionObj) {
    return axios.post('/api/MilestoneAction', milestoneActionObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  updateMilestoneAction (token, milestoneActionObj) {
    return axios.put('/api/MilestoneAction', milestoneActionObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  deleteMilestoneAction (token, milestoneActionId) {
    return axios.delete('/api/MilestoneAction?milestoneActionId=' + milestoneActionId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/milestone-service.js